import HmacSHA1 from 'crypto-js/hmac-sha1'
import MD5 from 'crypto-js/md5'
import SHA256 from 'crypto-js/sha256'
import Base64 from 'crypto-js/enc-base64'
import Utf8 from 'crypto-js/enc-utf8'

export const getHMACSHA1Hash = (msg: string, key: string): string => Base64.stringify(HmacSHA1(msg, key))

export const getMD5 = (msg: string): string => MD5(msg).toString()

export const getMD5Hash = (msg: string): string => Base64.stringify(MD5(msg))

export const utf8ToBase64 = (msg: string): string => Base64.stringify(Utf8.parse(msg))

export const base64ToUtf8 = (msg: string): string => Utf8.stringify(Base64.parse(msg))

export const getSHA256 = (msg: string): string => SHA256(msg).toString()
